//
//
//
//
//
//
//
//
//
//

import { imagePlaceholderProduct } from "~/common";
import MoominQuote from "~/themes/fiskarsMoominDefault/components/components/organisms/MoominQuote/MoominQuote.vue";
export default {
  name: "Quote",
  components: {
    MoominQuote,
  },
  props: {
    image: {
      type: Object,
      default: {
        desktop: imagePlaceholderProduct,
        mobile: imagePlaceholderProduct,
        thumbnail: imagePlaceholderProduct,
        alt: "image",
      },
    },
    imageUrl: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    background: {
      type: Object,
      default: "",
    }
  },
  methods: {
    getQuoteBackground() {
      return this.background?.background?.selectionValues[0]?.key;
    },
  },
};
